export default __webpack_public_path__ + "static/media/ticket_sent_catsul.554cb593.svg";